import { render, staticRenderFns } from "./TableClient.vue?vue&type=template&id=56b0553c&"
import script from "./TableClient.vue?vue&type=script&lang=js&"
export * from "./TableClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports